import axios from 'axios';
import { API_URL } from '../global/global';

class AIService {
  private baseURL = API_URL;
  private currentAudio: HTMLAudioElement | null = null;

  async processQuery(query: string, token?: string) {
    try {
      // Obtener token del localStorage si no se proporciona
      const authToken = token || localStorage.getItem('dhl_token');
      
      if (!authToken) {
        throw new Error('Token DHL no encontrado');
      }

      const response = await axios.post(`${this.baseURL}/ai/process`, {
        text: query,
        token: authToken
      });
      return response.data;
    } catch (error) {
      console.error('Error processing query:', error);
      throw error;
    }
  }

  async textToSpeech(text: string, token?: string): Promise<string | null> {
    try {
      // Obtener token del localStorage si no se proporciona
      const authToken = token || localStorage.getItem('dhl_token');
      
      if (!authToken) {
        throw new Error('Token DHL no encontrado');
      }

      const response = await axios.post(`${this.baseURL}/ai/text-to-speech`, {
        text,
        token: authToken
      });
      
      if (response.data.success) {
        // Convertir base64 a blob y crear URL
        const audioData = response.data.audio;
        const byteCharacters = atob(audioData);
        const byteNumbers = new Array(byteCharacters.length);
        
        for (let i = 0; i < byteCharacters.length; i++) {
          byteNumbers[i] = byteCharacters.charCodeAt(i);
        }
        
        const byteArray = new Uint8Array(byteNumbers);
        const audioBlob = new Blob([byteArray], { type: 'audio/mp3' });
        const audioUrl = URL.createObjectURL(audioBlob);
        
        return audioUrl;
      }
      
      return null;
    } catch (error) {
      console.error('Error generating speech:', error);
      return null;
    }
  }

  playAudio(audioUrl: string): Promise<HTMLAudioElement> {
    return new Promise((resolve, reject) => {
      // Detener audio anterior si existe
      this.stopAudio();
      
      this.currentAudio = new Audio(audioUrl);
      
      this.currentAudio.onended = () => {
        URL.revokeObjectURL(audioUrl);
        this.currentAudio = null;
      };
      
      this.currentAudio.onerror = () => {
        URL.revokeObjectURL(audioUrl);
        this.currentAudio = null;
        reject(new Error('Error playing audio'));
      };
      
      this.currentAudio.oncanplaythrough = () => {
        resolve(this.currentAudio!);
      };
      
      this.currentAudio.play().catch(reject);
    });
  }

  stopAudio(): void {
    if (this.currentAudio) {
      this.currentAudio.pause();
      this.currentAudio.currentTime = 0;
      this.currentAudio = null;
    }
  }

  getCurrentAudio(): HTMLAudioElement | null {
    return this.currentAudio;
  }
}

export default new AIService();
